import React from 'react';
import { PageLayout } from './PageLayout';
import { ROUTES } from '../config/routes';

/**
 * Error Boundary specifically for Auth0 errors
 * Catches and handles authentication-related errors gracefully
 */
export class Auth0ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false, 
      error: null,
      errorInfo: null 
    };
  }

  static getDerivedStateFromError(error) {
    // Check if it's an Auth0-related error
    const isAuthError = 
      error?.error?.includes('auth0') ||
      error?.message?.toLowerCase().includes('token') ||
      error?.message?.toLowerCase().includes('authentication') ||
      error?.error === 'login_required' ||
      error?.error === 'consent_required';

    return { 
      hasError: true,
      error: error,
      isAuthError: isAuthError 
    };
  }

  componentDidCatch(error, errorInfo) {
    // Log error to console or error tracking service
    console.error('Auth0ErrorBoundary caught an error:', error, errorInfo);
    
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  handleReset = () => {
    this.setState({ 
      hasError: false, 
      error: null,
      errorInfo: null 
    });
  };

  handleRetry = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      const { error, isAuthError } = this.state;
      const { children } = this.props;

      // If it's an auth error and we have a fallback, show fallback
      if (isAuthError && children) {
        // Let the AuthenticationGuard handle redirect
        return children;
      }

      // Otherwise show error page
      return (
        <PageLayout>
          <div className="content-layout" style={{ padding: '40px 20px', textAlign: 'center' }}>
            <h1 id="page-title" className="content__title">
              Authentication Error
            </h1>
            <div className="content__body">
              <p id="page-description">
                {error?.message || 'An authentication error occurred. Please try again.'}
              </p>
              {error?.error && (
                <p style={{ color: '#666', fontSize: '14px', marginTop: '10px' }}>
                  Error code: {error.error}
                </p>
              )}
              <div style={{ marginTop: '30px' }}>
                <button 
                  onClick={this.handleRetry}
                  style={{
                    padding: '10px 20px',
                    marginRight: '10px',
                    backgroundColor: '#007bff',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer'
                  }}
                >
                  Retry
                </button>
                <button 
                  onClick={() => window.location.href = ROUTES.HOME}
                  style={{
                    padding: '10px 20px',
                    backgroundColor: '#6c757d',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer'
                  }}
                >
                  Go to Home
                </button>
              </div>
            </div>
          </div>
        </PageLayout>
      );
    }

    return this.props.children;
  }
}
